import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import ShipmentTrackingReportActions from '../../Stores/ShipmentTrackingReport/Actions';

const { Panel } = Collapse;

class ShipmentTrackingReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initShipmentTracking } = this.props;

    if (curSiteFlowId > 0) {
      initShipmentTracking();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initShipmentTracking } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initShipmentTracking();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'shipment_tracking_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

ShipmentTrackingReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initShipmentTracking: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

ShipmentTrackingReportScreen.defaultProps = {
  intl: {},
  match: {},

  initShipmentTracking: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initShipmentTracking: () =>
    dispatch(ShipmentTrackingReportActions.shipmentTrackingReportInitShipmentTracking())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ShipmentTrackingReportScreen));
